import(/* webpackMode: "eager" */ "/app/src/modules/home/component/views/HomePage.tsx")